import React from 'react';

const CustomerFooter: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-6 py-6 flex justify-center items-center text-sm text-gray-600">
        <span>Powered by &nbsp;</span>
        <a
          href="https://vivaclub.io"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-violet-700 hover:text-violet-900 font-medium"
        >
          vivaclub.io
          {/* <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12l2-2 4 4 10-10 2 2-12 12-6-6z" />
          </svg> */}
          
        </a>
      </div>
    </footer>
  );
};

export default CustomerFooter;


